import lpActions from '../actions/lps/lpActionTypes';
import { initialContextValue } from '../context/CarrierLogisticsCommonsContext';
import { Action } from '../interfaces/CarrierLogisticCommons.interface';

export function lpsReducer(
  state = initialContextValue.lps,
  action: Action<string, Record<string, any>>
) {
  const { type, payload } = action;
  switch (type) {
    case lpActions.SET_AUTHORIZED_ENTITIES:
      return {
        ...state,
        authorizedEntities: payload,
      };
    case lpActions.SET_AUTHORIZED_LPS:
      return {
        ...state,
        authorizedLps: payload,
      };
    case lpActions.SET_AUTHORIZED_DSPS:
      return {
        ...state,
        authorizedDSPs: payload,
      };
    case lpActions.SET_SELECTED_LP:
      return {
        ...state,
        lpSelected: payload,
      };
    default:
      return state;
  }
}

export default lpsReducer;
